import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CURRENT_USER,
  CURRENT_USER_SUCCESS,
  CURRENT_USER_FAILURE,
  LOGIN_FAILURE,
  LOGOUT_USER_FAILURE,
  UPDATE_CURRENT_USER,
  UPDATE_CURRENT_USER_SUCCESS,
  UPDATE_CURRENT_USER_FAILURE,
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_FAILURE,
  VERIFY_USER,
  VERIFY_USER_SUCCESS,
  VERIFY_USER_FAILURE,
} from "./actionTypes";

const initialState = {
  user: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const authentication = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        isLoggedIn: true,
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        user: {},
        isLoggedIn: false,
      };

    // ===================================================
    // ===================================================

    case LOGOUT_USER:
      return {
        ...state,
        loading: true,
      };

    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: {},
        isLoggedIn: false,
      };

    case LOGOUT_USER_FAILURE:
      return {
        ...state,
        loading: false,
        user: {},
        isLoggedIn: false,
      };

    // ===================================================
    // ===================================================

    case CURRENT_USER:
      return {
        ...state,
        loading: true,
      };

    case CURRENT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        isLoggedIn: true,
      };

    case CURRENT_USER_FAILURE:
      return {
        ...state,
        loading: false,
        user: {},
        isLoggedIn: false,
      };

    // ===================================================
    // ===================================================

    case API_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case UPDATE_CURRENT_USER:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_CURRENT_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        isLoggedIn: true,
      };

    case UPDATE_CURRENT_USER_FAILURE:
      return {
        ...state,
        loading: false,
        user: {},
        isLoggedIn: false,
      };

    // ===================================================
    // ===================================================

    case UPDATE_PASSWORD:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // ===================================================
    // ===================================================

    case FORGET_PASSWORD:
      return {
        ...state,
        loading: true,
      };

    case FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case FORGET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // ===================================================
    // ===================================================

    case VERIFY_USER:
      return {
        ...state,
        loading: true,
      };

    case VERIFY_USER_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case VERIFY_USER_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // ===================================================
    // ===================================================

    default:
      return state;
  }
};

export default authentication;
